export const SHIRT_DISPLAY_OPTIONS = {
  measurements: true,
  points: true,
  seamWalk: true,
};
